module.exports = __webpack_public_path__ + "assets/img/parent_register_with_monkey.42b0c75c.png";